import VueJwtDecode from 'vue-jwt-decode';

export default class User {
    static from (token, RoleSecurity) {
        try {
            let obj = VueJwtDecode.decode(token);
            obj.RoleSecurity = JSON.parse(RoleSecurity);
            return new User(obj);
        } catch (_) {
            return null;
        }
    }

    constructor ({ UserLoginID, ContactID, FirstName, LastName, LoginRoleID, EmailAddress, Params, gid, RoleSecurity, RoleName, OrganizationID }) {
        this.UserLoginID = UserLoginID;
	    this.ContactID = ContactID;
	    this.FirstName = FirstName;
	    this.LastName = LastName;
	    this.LoginRoleID = LoginRoleID;
	    this.EmailAddress = EmailAddress;
	    this.Params = (typeof Params === 'string' ? JSON.parse(Params) : Params);
	    this.RoleSecurity = RoleSecurity;
	    this.gid = gid;
	    this.RoleName = RoleName;
	    this.OrganizationID = (OrganizationID == 0 ? '' : OrganizationID);
    }

}